<template>
    <div>
        <el-dialog
            title="异步庭审公告"
            :visible.sync="centerDialogVisible"
            :close-on-click-modal = false
            :close-on-press-escape = false
            :show-close = false
            width="720px"
            center
            class="dialog-content"
            >
            <div class="content">
                <div class="content-wrap">
                    <div class="content-list">
                        <div class="one">根据我国法律的有关规定，当事人在仲裁活动中享有如下权利：有委托代理人、申请回避的权利，有申诉、申辩、质询、质证、辩论、陈述最后意见的权利，有请求调解、自行和解、要求裁决的权利，有依法向人民法院提起诉讼、申请强制执行的权利；申请人有放弃、变更、撤回仲裁请求的权利；被申请人有承认、反驳申请人仲裁请求、提起反诉的权利。</div>
                    </div>
                    <div class="content-list">
                        <div class="one">当事人在仲裁活动中承担如下义务：有遵守仲裁程序和仲裁庭纪律的义务，有如实陈述案情、回答仲裁员提问的义务，有对自己提出的主张举证的义务，有尊重对方当事人及其他仲裁参加人的义务，有自觉履行发生法律效力的调解、裁决文书的义务。</div>
                    </div>

                    <div class="content-list">
                        <div class="one">根据《中华人民共和国劳动争议调解仲裁法》第三十三条的规定，如果当事人认为本庭组成人员以及书记员与本案有利害关系或其他关系，可能影响到本案公正审理的情形，可以申请本庭组成人员回避，但应说明理由和依据。</div>
                    </div>
                </div>
                <div class="select">温馨提示：可以在异步沟通中继续查看</div>
                <div class="dialog-footer">
                    <el-button type="primary" @click="openCase" ref="nextStep">确定</el-button>
                </div>
            </div>
        </el-dialog>
    </div>

</template>

<script>
    import { setStore, getStore, removeStore, setStoreSession, getStoreSession,removeStoreSession } from '@/utils/utils.js'

    export default {
        props: ['caseId'],
        data() {
            return {
                centerDialogVisible: true,
                checked: true,
                num:3,
                interval: null,
                params: {},
                commonUserFlag: false,
                currentLoginUserId: null,
                query: {}
            }
        },
        beforeRouteEnter(to, from, next) {
            if(~from.path.indexOf("/meeting")){
                removeStore('isOutter');   
                removeStore('flk');
                removeStoreSession('haslogin');
                removeStore('loginInfo');
                next({ path: '/login'})
            }else{
                next()
            }
        },
        created() {
            this.query = this.$route.query
        },
        mounted() {

        },
        methods: {
            openCase() {
               this.$router.push({
                   path:'/caseSpace',
                   query:this.query
               })
            }
        },
    }
</script>

<style lang="scss">
    .dialog-content {
        .content {
            .content-wrap {
                padding: 20px;
                border: 1px solid #dfdfdf;
            }
            .content-list {
                padding-bottom: 20px;
                .one {
                    color: #000000;
                    line-height: 32px;
                    font-size: 14px;
                }
                .two {
                    li {
                        height: 32px;
                        line-height: 32px;
                        text-indent: 0.5em;
                        font-size: 14px;
                        color: #787c7e;
                    }
                }
                .three {
                    line-height: 32px;
                    font-size: 14px;
                    color: #787c7e;
                }
            }
            .select {
                color: #0083c8;
                text-align: center;
                height: 40px;
                line-height: 60px;
            }
            .dialog-footer {
                padding-top: 26px;
                text-align: center;
            }
        }
    }
</style>
